<div class="row">
  <!-- Item Image -->
  <div class="cx-image-container col-2">
    <a [routerLink]="{ cxRoute: 'product', params: cartEntry.product } | cxUrl" tabindex="-1">
      <cx-media [container]="cartEntry.product.images?.PRIMARY" format="product"></cx-media>
    </a>
    <app-uig-marketplace-icon [marketplace]="cartEntry.product.marketplace" [vendor]="cartEntry.product.vendor"></app-uig-marketplace-icon>
  </div>
  <!-- Item Information -->
  <div class="cx-info col-10">
    <div class="cx-info-container row">
      <!-- Item Description -->
      <div class="col-md-5 col-lg-5 col-xl-5">
        @if (cartEntry.product.name) {
          <div class="cx-name">
          <a class="cx-link" [routerLink]="
              { cxRoute: 'product', params: cartEntry.product } | cxUrl
            ">{{ cartEntry.product.name }}</a>
          </div>
        }
        @if (cartEntry.product.code) {
          <div class="cx-code">
            {{ 'cartItems.id' | cxTranslate }} {{ cartEntry.product.code }}
          </div>
        }
        <!-- Variants -->
        @if (cartEntry.product.baseOptions?.length) {
          @for (
            variant of cartEntry.product.baseOptions[0]?.selected
            ?.variantOptionQualifiers
            ; track
            variant) {
            <div class="cx-property">
              @if (variant.name && variant.value) {
                <div class="cx-label">
                  {{ variant.name }}: {{ variant.value }}
                </div>
              }
            </div>
          }
        }
      </div>
      <!-- Item Price -->
      @if (cartEntry.basePrice) {
        <div class="col-md-3 col-lg-4 col-xl-4 cx-price">
          <div class="d-block d-md-none d-lg-none d-xl-none cx-label">
            {{ 'cartItems.itemPrice' | cxTranslate }}
          </div>
          @if (cartEntry.basePrice) {
            <div class="cx-value">
              {{ cartEntry.product?.ekPrice?.formattedValue }}
            </div>
          }
        </div>
      }
      <!-- Total -->
      <div class="col-sm-8 col-md-4 col-lg-3 col-xl-3 cx-add-to-cart">
        @if (cartEntry.product.stock.stockLevelStatus !== 'outOfStock') {
          <app-uig-add-to-cart
            [showQuantity]="false"
            [product]="cartEntry.product">
          </app-uig-add-to-cart>
        } @else {
          <span class="cx-out-of-stock">
            {{ 'addToCart.outOfStock' | cxTranslate }}
          </span>
        }
      </div>
    </div>
    <div class="row">
      <div class="cx-return-button col-sm-4 col-md-8 col-lg-9 col-xl-9"></div>
      <div class="cx-return-button col-sm-8 col-md-4 col-lg-3 col-xl-3">
        <button class="btn btn-secondary btn-block wish-list-item__cta" (click)="removeEntry(cartEntry)" [disabled]="isLoading">
          {{ 'common.remove' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
